export default __webpack_public_path__ + "static/media/Ballroll_00324.24b74aa2.png";